<template>
  <div id="vue-admin-beautiful">
    <a-config-provider :locale="locale" :componentSize="'middle'"
    :theme="{
      // 定制主题  https://www.antdv.com/docs/vue/customize-theme-cn#%E5%9C%A8-configprovider-%E4%B8%AD%E9%85%8D%E7%BD%AE%E4%B8%BB%E9%A2%98
      token: {
        fontSize: 15,
        // fontSize: 14,
        colorBgBase: '#FFFFE0',
        colorBorder: '#87CEFA',
        colorBorderSecondary: '#afafaf',
      },
    }">
      <router-view />
    </a-config-provider>
    <!-- 全局水印组件 -->
    <watermark 
      :text="watermarkName" 
      :fontSize="16" 
      :opacity="0.3" 
      :rotate="-30"
      :gap="40"
      color="rgba(0, 0, 0, 0.5)"
    />
  </div>
</template>
<script>
  import zhCN from 'ant-design-vue/es/locale/zh_CN'
  import 'dayjs/locale/zh-cn'
  import { getEnum } from '@/api/common'
  import { getModal } from '@/api/system_manage/modal'
  import { getData as getGate } from '@/api/equipment_management/gate'
  import { getDept } from '@/api/system_manage/dept'
  import { getNoticeTypeEnum, getNoticeStatusEnum } from '@/api/notice/notice'
  import { getUser } from '@/api/system_manage/userManage'
  import { capitalizeFirstLetter, resListToEnum } from '@/utils/format'
  import { allEnum } from '@/utils/common'
  import store from './store'
  import dayjs from 'dayjs'
  import { getAccessToken } from '@/utils/auth'

  export default {
    name: 'App',
    data() {
      return {
        locale: zhCN,
      }
    },
    mounted() {
      dayjs.locale('zh-cn')
      this.getAllEnum()
    },
    computed: {
      username() {
        return store.getters['user/username']
      },
      account() {
        return store.getters['user/account']
      },
      watermarkName() {
        return this.username + ' ' + this.account
      },
    },
    methods: {
      //获取所有映射表
      async getAllEnum () {
        if (!getAccessToken()) return
        const typeEnum = await getNoticeTypeEnum()
        store.dispatch('common/setNoticeType', typeEnum.data, { saveData: true })
        const statusEnum = await getNoticeStatusEnum()
        store.dispatch('common/setNoticeStatus', statusEnum.data, { saveData: true })

        for (let i in allEnum) {
          const item = allEnum[i]
          let name = item,
            value = item
          if (item.constructor === Object) {
            name = item.name
            value = item.value
          }
          getEnum({ name }).then((res) => {
            if (res.success) {
              const actionName = 'common/set' + capitalizeFirstLetter(value)
              store.dispatch(actionName, res.data)
            }
          })
        }

        getModal({
          size: Number.MAX_SAFE_INTEGER,
          pn: 1,
        }).then((res) => {
          store.dispatch(
            'common/setCarModel',
            resListToEnum(res.data.list, { toString: true })
          )
          store.dispatch(
            'common/setCarModelObj',
            resListToEnum(res.data.list, { saveData: true })
          )
        })

        getDept().then((res) => {
          store.dispatch(
            'common/setDept',
            resListToEnum(res.data, { idName: 'depart_id' })
          )

          // 保存机构类型
          store.dispatch(
            'common/setDeptType',
            resListToEnum(res.data, { idName: 'depart_id', valueName: 'depart_type' })
          )
        })
        getGate({
          size: 999,
          pn: 1,
          state: -1,
          type: -1,
        }).then((res) => {
          store.dispatch('common/setGate', resListToEnum(res.data.list));

          let carGate = [];
          let personGate = [];

          for (let i = 0; i < res.data.list.length; i++) {
            let item = res.data.list[i];
            if(item['type'] == 1) {
              carGate.push(item);
            } else if (item['type'] == 2) {
              personGate.push(item);
            }
          }
          store.dispatch('common/setCarGate', resListToEnum(carGate));
          store.dispatch('common/setPersonGate', resListToEnum(personGate));
          console.log(carGate)
          console.log(personGate)
        })
        getUser({
          size: 999999,
          pn: 1,
        }).then((res) => {
          store.dispatch(
            'common/setUser',
            resListToEnum(res.data.list, {
              idName: 'user_id',
              valueName: 'user_name',
            })
          )
        })
      },
    },
  }
</script>
<style lang="less">
  @import '~@/vab/styles/vab.less';
  @import '~@/assets/common.less';
</style>
